import script from "./DownloadDataFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadDataFile.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadDataFile.vue?vue&type=style&index=0&id=9735e318&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9735e318"]])

export default __exports__